"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Url_1 = require("../Url");
var BaseApiService_1 = require("../../apiServices/baseApiService/BaseApiService");
var EngineeringModel = /** @class */ (function () {
    function EngineeringModel() {
    }
    EngineeringModel.prototype.GetEnggModel = function (storageId, sceModelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = Url_1.url.GetEnggModel + "?storageId=" + storageId + "&sceModelId=" + sceModelId;
                return [2 /*return*/, BaseApiService_1.BaseApiService.get(url)];
            });
        });
    };
    EngineeringModel.prototype.StoreEnggModel = function (sceModel, storageId, modelId, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = '';
                if (modelId !== undefined && typeId !== undefined && version !== undefined) {
                    url = Url_1.url.StoreEnggModel + "?storageId=" + storageId + "&modelId=" + modelId + "&typeId=" + typeId + "&version=" + version;
                }
                else {
                    url = Url_1.url.StoreEnggModel + "?storageId=" + storageId + "&modelId=&typeId=&version=";
                }
                return [2 /*return*/, BaseApiService_1.BaseApiService.post(url, sceModel)];
            });
        });
    };
    EngineeringModel.prototype.UpdateEnggModel = function (sceModel, storageId, modelId, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = '';
                if (modelId !== undefined && typeId !== undefined && version !== undefined) {
                    url = Url_1.url.UpdateEnggModel + "?storageId=" + storageId + "&modelId=" + modelId + "&typeId=" + typeId + "&version=" + version;
                }
                else {
                    url = Url_1.url.UpdateEnggModel + "?storageId=" + storageId + "&modelId=&typeId=&version=";
                }
                return [2 /*return*/, BaseApiService_1.BaseApiService.put(url, sceModel)];
            });
        });
    };
    EngineeringModel.prototype.DeleteEnggModel = function (storageId, sceModelId, modelId, typeId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = '';
                if (modelId !== undefined && typeId !== undefined) {
                    url = Url_1.url.DeleteEnggModel + "?storageId=" + storageId + "&sceModelId=" + sceModelId + "&modelId=" + modelId + "&typeId=" + typeId;
                }
                else {
                    url = Url_1.url.DeleteEnggModel + "?storageId=" + storageId + "&sceModelId=" + sceModelId + "&modelId=&typeId=";
                }
                return [2 /*return*/, BaseApiService_1.BaseApiService.delete(url)];
            });
        });
    };
    return EngineeringModel;
}());
exports.EngineeringModel = EngineeringModel;
//# sourceMappingURL=EngineeringModel.js.map